export default class LoadMore {
    constructor() {
        this.settings = {
            $postsList: $(".js-posts-list")
        };

        this.currentPage = 1;
        this.isLoading = false;
        this.hasMore = true;
        this.lastScrollTime = 0;
        this.lastTriggerHeight = 0;
        this.loadingDisabled = false;
        this.isScrolling = false;
        this.temporarilyPaused = false;
        this.navigatingToContact = false;

        this.bindUIActions();
    }

    bindUIActions() {
        if (!this.settings.$postsList.length) return;

        const postsList = this.settings.$postsList;
        const postsPerPage = $('#js-nr-posts-load-more').val();
        const isPostsBlock = postsList.closest('[data-block="posts-filter-grid"]').length > 0;
        const isCareersBlock = postsList.closest('[data-block="careers-filter-grid"]').length > 0;
        
        if (!isPostsBlock && !isCareersBlock) return;

        const loadMoreOnScroll = () => {
            if (this.isLoading || !this.hasMore || this.loadingDisabled || this.temporarilyPaused || this.navigatingToContact) {
                return;
            }

            const now = Date.now();

            if (now - this.lastScrollTime < 500) return; // Increased throttle

            this.lastScrollTime = now;
            this.isScrolling = true;
            
            // Clear scrolling flag after a delay
            clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(() => {
                this.isScrolling = false;
            }, 800); // Longer delay

            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const documentHeight = $(document).height();
            const postsListTop = postsList.offset().top;
            const postsListHeight = postsList.outerHeight();
            const postsListBottom = postsListTop + postsListHeight;
            const viewportTop = scrollTop;
            const viewportBottom = scrollTop + windowHeight;
            const isGridVisible = (viewportTop < postsListBottom) && (viewportBottom > postsListTop);
            
            if (isGridVisible && this.hasMore && !this.isLoading) {
                const triggerPoint = postsListBottom - (windowHeight * 0.5);
                
                if (viewportBottom >= triggerPoint && scrollTop > this.lastTriggerHeight) {
                    this.lastTriggerHeight = scrollTop;
                    
                    setTimeout(() => {
                        if (!this.isLoading && !this.temporarilyPaused && !this.navigatingToContact && this.hasMore) {
                            this.loadMorePosts(postsPerPage, isPostsBlock);
                        }
                    }, 100);
                }
            }
        };

        $(window).on('scroll.loadmore', loadMoreOnScroll);
        
        this.loadMoreScrollHandler = loadMoreOnScroll;
        this.addSkipButton(postsList, isPostsBlock);
    }

    applyCSSHeightEqualization() {
        const currentScroll = $(window).scrollTop();
        const $grid = this.settings.$postsList;
        const $allCards = $grid.find('.js-post-single');
        
        if (!$allCards.length) return;
        
        $allCards.each(function() {
            const $card = $(this);
            
            // Skip if already processed
            if ($card.hasClass('height-equalized')) return;
            
            $card.addClass('flex flex-col h-full height-equalized');
            
            const $image = $card.find('img');

            if ($image.length) {
                $image.addClass('h-48 min-h-48 object-cover object-center w-full');
            }
            
            const $content = $card.find('[data-mh="post-card"]');

            if ($content.length) {
                $content.addClass('flex flex-col flex-grow h-full justify-between');
                
                const $title = $content.find('h2, .post-card-heading');
                const $excerpt = $content.find('p');
                const $metaInfo = $content.find('.flex.items-center.gap-2').first();
                const $button = $content.find('.btn');
                
                // Only create top section if it doesn't exist
                if (($title.length || $excerpt.length) && !$content.find('.top-content').length) {
                    const $topSection = $('<div class="top-content flex-grow-0 flex-shrink-0"></div>');
                    
                    if ($title.length) {
                        $title.appendTo($topSection);
                    }
                    if ($excerpt.length) {
                        $excerpt.appendTo($topSection);
                    }
                    
                    $content.prepend($topSection);
                }
                
                // Only create bottom section if it doesn't exist
                if (($metaInfo.length || $button.length) && !$content.find('.bottom-content').length) {
                    const $bottomSection = $('<div class="bottom-content mt-auto flex-grow-0 flex-shrink-0 pt-4"></div>');
                    
                    if ($metaInfo.length) {
                        $metaInfo.appendTo($bottomSection);
                    }
                    if ($button.length) {
                        $button.appendTo($bottomSection);
                    }
                    $content.append($bottomSection);
                }
                
                if ($metaInfo.length) {
                    $metaInfo.addClass('flex flex-nowrap items-center gap-2');
                    $metaInfo.find('div.flex.gap-2').addClass('inline-flex flex-nowrap items-center gap-2');
                    $metaInfo.find('span, time').addClass('whitespace-nowrap flex-shrink-0');
                    $metaInfo.find('.flex-wrap').addClass('flex-nowrap');
                }
                
                if ($button.length) {
                    $button.addClass('mt-4');
                }
            }
        });
        
        $(window).scrollTop(currentScroll);
    }

    loadMorePosts(postsPerPage, isPostsBlock) {
        // Prevent multiple simultaneous requests for the same page
        if (this.isLoading) {
            return;
        }
        
        this.isLoading = true;
        const nextPage = this.currentPage + 1;

        const $loadingIndicator = $(`
            <div class="loading-more text-center py-8">
                <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-hd-purple"></div>
                <p class="mt-2 text-hd-purple">Loading more...</p>
            </div>
        `);
        this.settings.$postsList.after($loadingIndicator);

        const blockType = isPostsBlock ? 'posts' : 'careers';
        const formData = new FormData();
        
        formData.append('action', 'load_more_posts');
        formData.append('page', nextPage);
        formData.append('posts_per_page', postsPerPage);
        formData.append('block_type', blockType);

        if (isPostsBlock) {
            const form = $('form[name="category"]');
            formData.append('content_type', form.find('[name="content_type"]').val() || '');
            formData.append('blog_service', form.find('[name="blog_service"]').val() || '');
            formData.append('blog_sector', form.find('[name="blog_sector"]').val() || '');
            formData.append('blog_author', form.find('[name="blog_author"]').val() || '');
            formData.append('blog_topic', form.find('[name="blog_topic"]').val() || '');
            formData.append('read_more_label', $('#js-read-more-label').val() || 'Read More');
        } else {
            const form = $('form[name="filter-form"]');
            formData.append('location', form.find('[name="location"]').val() || '');
            formData.append('role', form.find('[name="role"]').val() || '');
            formData.append('area', form.find('[name="area"]').val() || '');
            formData.append('find_out_more_label', $('#js-find-out-more-label').val() || 'Find Out More');
        }

        $.ajax({
            url: window.ajaxurl || '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
                $('.loading-more').remove();
                
                if (response.success && response.data.html) {
                    const currentScrollTop = $(window).scrollTop();
                    const $newContent = $(response.data.html);
                    
                    // Check if content already exists to prevent duplicates
                    const existingPostUrls = [];
                    this.settings.$postsList.find('a.js-post-single').each(function() {
                        existingPostUrls.push($(this).attr('href'));
                    });
                    
                    // Filter out any posts that already exist
                    const $filteredContent = $newContent.filter(function() {
                        const $element = $(this);
                        // Check if this element is the post link itself
                        if ($element.hasClass('js-post-single')) {
                            const href = $element.attr('href');
                            return !existingPostUrls.includes(href);
                        }
                        // For other elements, check if they contain a post link
                        const $link = $element.find('a.js-post-single');
                        if ($link.length === 0) return true; // Keep non-post elements
                        const href = $link.attr('href');
                        return !existingPostUrls.includes(href);
                    });
                    
                    // Only proceed if we have new, unique content
                    if ($filteredContent.length === 0) {
                        this.hasMore = false;
                        this.isLoading = false;
                        return;
                    }
                    
                    $(window).off('scroll.loadmore scroll.skipbutton touchmove.skipbutton resize.skipbutton orientationchange.skipbutton');
                    
                    $filteredContent.addClass('opacity-0 invisible');
                    this.settings.$postsList.append($filteredContent);
                    this.hasMore = response.data.has_more;
                    
                    // Only increment current page AFTER successful response
                    this.currentPage = nextPage;
                    
                    $(window).scrollTop(currentScrollTop);
                    
                    setTimeout(() => {
                        $(window).scrollTop(currentScrollTop);
                        $filteredContent.removeClass('invisible').animate({ opacity: 1 }, 200);
                        
                        setTimeout(() => {
                            $(window).on('scroll.loadmore', this.loadMoreScrollHandler);
                            $(window).on('scroll.skipbutton touchmove.skipbutton', this.skipButtonScrollHandler);

                            const self = this;

                            $(window).on('resize.skipbutton orientationchange.skipbutton', () => {
                                setTimeout(self.updateSkipButtonVisibility, 100);
                            });
                            
                            this.applyCSSHeightEqualization();
                            this.isLoading = false;
                        }, 100);
                    }, 50);
                    
                } else {
                    this.hasMore = false;
                    this.isLoading = false;
                }
            },
            error: () => {
                $('.loading-more').remove();
                this.isLoading = false;
                // No need to decrement currentPage since we never incremented it
            }
        });
    }
    
    addSkipButton(postsList, isPostsBlock) {
        const gridSection = postsList.closest('section');
        
        const $skipButton = $(`
            <div class="skip-to-contact-form fixed bottom-8 left-1/2 transform -translate-x-1/2 z-10 text-center pointer-events-auto">
                <a href="#get-in-touch-form" target="_self" class="btn btn--purple">Get in touch</a>
            </div>
        `);
        
        
        let clickTimeout;
        $skipButton.find('a').on('click', (e) => {
            e.preventDefault();
            
            // Prevent click if currently loading or actively scrolling
            if (this.isLoading || this.isScrolling) {
                return;
            }
            
            // Clear any existing timeout
            if (clickTimeout) {
                clearTimeout(clickTimeout);
            }
            
            // Add a delay to prevent accidental clicks during scrolling
            clickTimeout = setTimeout(() => {
                // Double-check we're not loading or scrolling
                if (this.isLoading || this.isScrolling) {
                    return;
                }
                
                // Immediately disable all loading functionality
                this.navigatingToContact = true;
                this.temporarilyPaused = true;
                
                // Temporarily disable ALL scroll event listeners
                $(window).off('scroll.loadmore');
                $(window).off('scroll.skipbutton touchmove.skipbutton resize.skipbutton orientationchange.skipbutton');
                
                const $contactForm = $('#get-in-touch-form');

                if ($contactForm.length) {
                    // Stop any current animations to prevent conflicts
                    $('html, body').stop(true, false);
                    const self = this;
                    $('html, body').animate({
                        scrollTop: $contactForm.offset().top - 20
                    }, 800, function() {
                        $(window).on('scroll.loadmore', self.loadMoreScrollHandler);
                        $(window).on('scroll.skipbutton touchmove.skipbutton', self.skipButtonScrollHandler);
                        $(window).on('resize.skipbutton orientationchange.skipbutton', () => {
                            setTimeout(self.updateSkipButtonVisibility, 100);
                        });
                    });
                }
            }, 300);
        });
        
        const updateSkipButtonVisibility = () => {
            if (this.loadingDisabled) {
                $skipButton.hide();
                return;
            }
            
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const postsListTop = postsList.offset().top;
            const postsListHeight = postsList.outerHeight();
            const postsListBottom = postsListTop + postsListHeight;
            const viewportTop = scrollTop;
            const viewportBottom = scrollTop + windowHeight;
            
            // Check if we've reached the posts grid section (more lenient detection for mobile)
            const gridSectionReached = viewportBottom >= (postsListTop - 50);
            const isGridVisible = (viewportTop < postsListBottom) && (viewportBottom > postsListTop);
            
            // Simple resume logic: if grid is visible and we were paused, resume loading
            if (isGridVisible && (this.temporarilyPaused || this.navigatingToContact)) {
                this.temporarilyPaused = false;
                this.navigatingToContact = false;
                // Reset trigger height to current scroll position to allow loading to continue
                this.lastTriggerHeight = scrollTop - 100; // Set it slightly below current position
            }
            
            // Show button when we've reached the posts grid section AND it's still visible
            // Hide when we've scrolled past the grid section completely
            if (gridSectionReached && isGridVisible) {
                $skipButton.show();
            } else {
                $skipButton.hide();
            }
        };
        
        // Initial visibility check - call immediately and after a short delay to ensure DOM is ready
        updateSkipButtonVisibility();
        setTimeout(updateSkipButtonVisibility, 100);
        
        let skipButtonThrottle;
        const throttledUpdateSkipButtonVisibility = () => {
            clearTimeout(skipButtonThrottle);
            skipButtonThrottle = setTimeout(updateSkipButtonVisibility, 100); // Reduced from 300ms to 100ms for better mobile responsiveness
        };
        
        // Bind scroll event with improved mobile/iOS handling
        $(window).on('scroll.skipbutton', throttledUpdateSkipButtonVisibility);
        
        // Add touchmove event for better iOS scroll detection
        $(window).on('touchmove.skipbutton', throttledUpdateSkipButtonVisibility);
        
        // Add resize event to handle orientation changes on mobile
        $(window).on('resize.skipbutton orientationchange.skipbutton', () => {
            setTimeout(updateSkipButtonVisibility, 100);
        });
        this.skipButtonScrollHandler = throttledUpdateSkipButtonVisibility;
        this.updateSkipButtonVisibility = updateSkipButtonVisibility;
        
        const originalLoadMorePosts = this.loadMorePosts.bind(this);

        this.loadMorePosts = (...args) => {
            originalLoadMorePosts(...args);
            setTimeout(updateSkipButtonVisibility, 100);
        };
        
        gridSection.append($skipButton);
    }
}

new LoadMore();